import React, {Fragment} from "react";
import {
  IConditionalStrikeThroughProps,
  IConditionalStrikeThroughPriceProps,
} from "../types";

export const ConditionalStrikeThrough = ({
  currency,
  price,
  noStrike,
}: IConditionalStrikeThroughProps) => {
  let template;
  const priceClass = noStrike
    ? "product-price__no-strike"
    : "product-price__strike";
  const roleText = "text";

  if (price.min) {
    template = (
      <Fragment>
        <span
          aria-label={`Was ${currency}${price.min} to ${currency}${price.max}`}
          className={priceClass}
          role={roleText}
        >
          {`${currency}${price.min}`} - {`${currency}${price.max}`}
        </span>
      </Fragment>
    );
  } else {
    template = (
      <span
        aria-label={`Was ${currency}${price}`}
        className={priceClass}
        role={roleText}
      >
        {`${currency}${price}`}
      </span>
    );
  }

  return template;
};

export const ConditionalStrikeThroughPrice = ({
  regularPriceAriaLabel,
  regularPriceText,
  noStrike,
}: IConditionalStrikeThroughPriceProps) => {
  const priceClass = noStrike
    ? "product-price__no-strike"
    : "product-price__strike";
  const roleText = "text";

  return (
    <span
      aria-label={regularPriceAriaLabel}
      className={priceClass}
      role={roleText}
    >
      {regularPriceText}
    </span>
  );
};
